<template>
  <div class="page-layout blank contacts-manage">
    <div class="breadcrumbnew">
      <a>Sales Forecasting</a>
      <span>Settings</span>
    </div>
    <div class="main">
      <div class="settings-heading d-flex align-items-center px-10">
        <p class="m-0" style="color:#fff;font-weight:bold;">Forecast Mapping</p>
      </div>
      <div class="settings-body px-10 py-8">
        <div class="row d-flex align-items-center" style="width: 100%">
          <div class="col-lg-3 pt-1" style="height: 20px">
            <p class="m-0">Data Comes From :</p>
          </div>
          <div class="col-lg-5 d-flex flex-row">
            <multiselect
              :max-height="250"
              class="digi-multiselect loaderbgwhite mr-10"
              v-model="quotationsVmodel"
              placeholder="Select Quotation"
              :options="quotations"
              :multiple="false"
              :taggable="false"
              :close-on-select="true"
              :show-labels="false"
              :clear-on-select="false"
            ></multiselect>
            <button class="btn btn-green-flat" @click="saveQuotation">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      quotations: ["Sales Order", "Sales Quotation"],
      quotationsVmodel: "",
    };
  },
  methods: {
    async saveQuotation() {
      let dataFrom = "";
      if (this.quotationsVmodel === "Sales Order") {
        dataFrom = "sales_order";
      } else if (this.quotationsVmodel === "Sales Quotation") {
        dataFrom = "sales_quotation";
      }
      let params = {
        sales_forecast: {
          data_from: dataFrom,
        },
      };
      let res = await this.$http.post("sales/add", params);
      if (res.data.status_id == 1) {
        this.$awn.success("Updated Successfully");
      }
    },
  },
  mounted() {
    this.$http.get("/sales/get").then(res => {
      if (res.data.status_id == 1) {
        if (res.data.response.sales_forecast.data_from == "sales_order") {
          this.quotationsVmodel = "Sales Order";
        } else {
          this.quotationsVmodel = "Sales Quotation";
        }
      }
    });
  },
};
</script>

<style>
.settings-heading {
  background-color: #005dae;
  height: 6rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.settings-body {
  box-shadow: 0 7px 32px 0 rgba(0, 0, 0, 0.07);
  background-color: #ecf1f9;
  height: 20rem;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/SettingsSalesForecast.vue